module.exports = __webpack_public_path__ + "img/product-placeholder-12.b412c02.png";